

import CryptoJS from 'crypto-js';

export class FileHashManager {
    public static async calculateFileHash(file: File): Promise<string> {
      return new Promise((res) => {
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onloadend = () => {
          const hash = CryptoJS.MD5(reader.result).toString();
          res(hash);
        };
      });
    }
}


